import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters, mapActions } from 'vuex';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart.svg';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/heart-full.svg';
import showNotification from '~/helpers/notification-helper';
export default {
  name: 'Heart',
  props: {
    reference: {
      type: String,
      required: true
    },
    withText: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mdmUrls: {
        moodboard: '/account/moodboard'
      }
    };
  },

  computed: _objectSpread({}, mapGetters({
    user: 'customer/user',
    userLogged: 'customer/isConnected',
    wishlist: 'wishlist/wishlist',
    loadingWishlist: 'wishlist/loadingWishlist'
  }), {
    isInWishlist() {
      return this.wishlist && this.includesRef(this.reference);
    },

    btnText() {
      return this.isInWishlist ? this.$t('delete.btn_label') : this.$t('add.btn_label');
    }

  }),
  watch: {
    user() {
      if (this.userLogged && !this.loadingWishlist) {
        this.getWishlist();
      }
    }

  },
  methods: _objectSpread({}, mapActions({
    getWishlist: 'wishlist/getWishlist',
    hpost: 'wishlist/postItem',
    hdel: 'wishlist/deleteItem'
  }), {
    toggleWishlist(ref, $event) {
      if (this.includesRef(ref)) {
        this.removeFromWishlist(ref, $event);
      } else {
        this.addToWishlist(ref, $event);
      }
    },

    includesRef(ref) {
      return this.wishlist != null && this.wishlist.product != null && this.wishlist.product.includes(ref);
    },

    addToWishlist(ref, $event) {
      var _this = this;

      return _asyncToGenerator(function* () {
        if (!_this.userLogged) {
          _this.$root.$emit('open-layer', {
            state: true,
            name: 'LoginRegister'
          });

          _this.tracking({
            ref,
            action: 'Add-to-wishlist',
            label: 'not_connected',
            el: $event
          });

          return;
        }

        _this.tracking({
          ref,
          action: 'Add-to-wishlist',
          el: $event
        });

        const data = {
          type: 'product',
          reference: ref
        };
        yield _this.hpost(data);
        showNotification({
          text: _this.$i18n.messages[_this.$store.state.i18n.currentLocale.language].add.subtitle,
          destination: "/".concat(_this.$store.state.i18n.currentLocale.market, "/").concat(_this.$store.state.i18n.currentLocale.language).concat(_this.mdmUrls.moodboard),
          backgroundColor: 'green'
        });
      })();
    },

    removeFromWishlist(ref, $event) {
      var _this2 = this;

      return _asyncToGenerator(function* () {
        if (!_this2.userLogged) {
          _this2.$root.$emit('open-layer', {
            state: true,
            name: 'LoginRegister'
          });

          _this2.tracking({
            ref,
            action: 'Remove-from-wishlist',
            label: 'not_connected',
            el: $event
          });

          return;
        }

        _this2.tracking({
          ref,
          action: 'Remove-from-wishlist',
          el: $event
        });

        const data = {
          type: 'product',
          reference: ref
        };
        yield _this2.hdel(data);
        showNotification({
          text: _this2.$i18n.messages[_this2.$store.state.i18n.currentLocale.language].delete.subtitle,
          destination: "/".concat(_this2.$store.state.i18n.currentLocale.market, "/").concat(_this2.$store.state.i18n.currentLocale.language).concat(_this2.mdmUrls.moodboard),
          backgroundColor: 'green'
        });
      })();
    },

    tracking(_ref) {
      var _this3 = this;

      return _asyncToGenerator(function* () {
        let {
          ref,
          action,
          label,
          el
        } = _ref;
        let category = '';

        if (window.tc_vars.env_template === 'listproduct_keyword') {
          category = 'Search Page';
        }

        if (window.tc_vars.env_template === 'liste produits') {
          category = 'Categorie';
        }

        if (window.tc_vars.env_template === 'page produit') {
          category = 'FicheProduit';
        }

        const defaultLabel = "".concat(window.tc_vars.page_cat1 || '', "_").concat(window.tc_vars.page_cat3 || '', "_").concat(ref);

        _this3.$root.$emit('generic-tracking', el, {
          data: {
            event_category: category,
            event_action: action,
            event_label: label || defaultLabel
          }
        });
      })();
    }

  })
};